import { render, staticRenderFns } from "./new_payment_event.vue?vue&type=template&id=282e455c&scoped=true&"
import script from "./new_payment_event.vue?vue&type=script&lang=js&"
export * from "./new_payment_event.vue?vue&type=script&lang=js&"
import style0 from "./new_payment_event.vue?vue&type=style&index=0&id=282e455c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e455c",
  null
  
)

export default component.exports